import { render, staticRenderFns } from "./CheckoutPayment.vue?vue&type=template&id=35acc04a&scoped=true"
import script from "./CheckoutPayment.vue?vue&type=script&lang=js"
export * from "./CheckoutPayment.vue?vue&type=script&lang=js"
import style0 from "./CheckoutPayment.vue?vue&type=style&index=0&id=35acc04a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35acc04a",
  null
  
)

export default component.exports